export enum ErrorName {
    INCORRECT_CODE = "Error",
    SIGNIN_EXCEPTION = 'SignInException',
    NOT_AUTHORIZED_EXCEPTION = 'NotAuthorizedException',
    USER_NOT_FOUND_EXCEPTION = 'UserNotFoundException',
    NO_SESSION = 'NoSession',
}

export enum CardStatus {
    LOST = 'LOST',
    STOLEN = 'STOLEN',
    DAMAGED = 'DAMAGED'
}

export enum ProductClassCode {
    SUITS_ESS_ACC_GBP = 'SUITS_ESS_ACC_GBP',
    SUITS_PREM_ACC_GBP = 'SUITS_PREM_ACC_GBP',
    SUITS_PREMP_ACC_GBP = 'SUITS_PREMP_ACC_GBP',
}

export enum CardProvider {
    EPS = "EPS",
    TRIBE = "Tribe"
}

export enum CardFramePage {
    SHOW_PIN = 'show-pin',
    ACTIVATE_CARD = 'activate-card'
}

export enum PayeeType {
    PERSONAL = 'PERSONAL',
    BUSINESS = 'BUSINESS',
}

export enum CaseType {
    ANNM = 'ANNM',
    OPTO = 'OPTO',
    CASS = 'CASS',
    AC01 = 'AC01',
    SCNS = 'SCNS',
    IVCR = 'IVCR',
    ACNS = 'ACNS',
    PAMM = 'PAMM',
    MBAM = 'MBAM',
    BANM = 'BANM',
    PANM = 'PANM',
    BAMM = 'BAMM',
    E500 = 'E500'
}

export enum FeesAction {
    STANDING_ORDER = 'standingOrder',
    PAYMENT = 'payment',
}

export enum AccountMigrationStatus {
    AWAITING_MIGRATION = 'AWAITING_MIGRATION',
    MIGRATING = 'MIGRATING',
    MIGRATED = 'MIGRATED',
}

export enum Currency {
    GBP = 'GBP',
    EUR = 'EUR',
    USD = 'USD',
    BGN = 'BGN',
}